import { useReactiveVar } from '@apollo/client';
import { useMsal } from '@azure/msal-react';
import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle
} from '@mui/material';
import { sessionExpiredVar } from '../state/sessionExpired';

/**
 * Modal shown when the Apollo error link detects a genuine HTTP 401 from the
 * backend (an expired/rejected auth token). Cannot be dismissed — the only way
 * out is to sign back in via MSAL's interactive redirect flow.
 */
export const SessionExpiredDialog = () => {
  const open = useReactiveVar(sessionExpiredVar);
  const { instance } = useMsal();

  const handleSignIn = () => {
    instance.loginRedirect();
  };

  return (
    <Dialog open={open} disableEscapeKeyDown aria-labelledby="session-expired-dialog-title">
      <DialogTitle id="session-expired-dialog-title">Session expired</DialogTitle>
      <DialogContent>
        <DialogContentText>
          Your sign-in has expired. Sign back in to continue.
        </DialogContentText>
      </DialogContent>
      <DialogActions>
        <Button onClick={handleSignIn} variant="contained" autoFocus>
          Sign back in
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default SessionExpiredDialog;
